import React, { useState, useContext, useEffect, useRef } from 'react';
import { AuthContext } from '../AuthContext';
import AppBreadCrumb from '../common/AppBreadCrumb';
import AppToaster from '../AppToaster';
import { getAvatar } from '../../commonfunctions';
import { handleApiError } from '../../api/risapi';
import { updateUserProfile } from '../../api/UsersAPI';

const UserProfilePage = () => {
    const { user: authUser, setUser: setAuthUser } = useContext(AuthContext); // Use user/setUser from context
    const [displayUser, setDisplayUser] = useState(null); // Local state for form
    const [errors, setErrors] = useState({});
    const [showToaster, setShowToaster] = useState(false);
    const [toaster, setToaster] = useState({});
    const fileInputRef = useRef(null);
    const [previewImage, setPreviewImage] = useState(null);

    useEffect(() => {
        // This check ensures we only proceed when the authUser object is fully loaded
        if (authUser && authUser.name) {
            setDisplayUser({
                name: authUser.name,
                phone_number: authUser.phone_number,
                roles: authUser.roles?.map(role => role.name).join(', ') || 'No Role Assigned',
                profile_pic: null,
                password: '',
                password_confirmation: ''
            });
            setPreviewImage(getAvatar(authUser.profile_pic_path));
        }
    }, [authUser]);

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setDisplayUser({ ...displayUser, profile_pic: file });
            setPreviewImage(URL.createObjectURL(file));
        }
    };

    const handleSaveChanges = (e) => {
        e.preventDefault();
        setErrors({});
        // Send the local form state for update
        updateUserProfile(displayUser, (response) => {
            if (response.user) {
                setAuthUser(response.user); // Update global context with new user data
                setToaster({ type: 'success', heading: 'Success', message: response.message });
                setShowToaster(true);
                // Clear password fields in local state after successful submission
                setDisplayUser(prev => ({...prev, password: '', password_confirmation: ''}));
            } else if (response.error) {
                handleApiError(response.error, setErrors);
            }
        });
    };

    if (!displayUser) {
        return <div className="d-flex justify-content-center align-items-center vh-100"><div className="spinner-border" role="status"><span className="visually-hidden">Loading...</span></div></div>;
    }

    return (
        <>
            <AppToaster showToaster={showToaster} setShowToaster={setShowToaster} toaster={toaster} />
            <main>
                <div className="container-fluid">
                    <AppBreadCrumb title="User Profile" />
                    <div className="card">
                        <div className="card-body">
                            <form onSubmit={handleSaveChanges}>
                                <div className="row">
                                    <div className="col-md-4 text-center">
                                        <img src={previewImage} alt="Profile" className="img-fluid rounded-circle mb-3" style={{ width: '150px', height: '150px', objectFit: 'cover' }}/>
                                        <input type="file" ref={fileInputRef} onChange={handleImageChange} className="d-none" accept="image/*"/>
                                        <button type="button" className="btn btn-outline-primary btn-sm" onClick={() => fileInputRef.current.click()}>Change Picture</button>
                                        {errors.profile_pic && <div className="text-danger mt-1">{errors.profile_pic[0]}</div>}
                                    </div>
                                    <div className="col-md-8">
                                        <div className="mb-3">
                                            <label className="form-label">Full Name</label>
                                            <input type="text" className="form-control" value={displayUser.name} onChange={(e) => setDisplayUser({ ...displayUser, name: e.target.value })}/>
                                            {errors.name && <div className="text-danger">{errors.name[0]}</div>}
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label">Phone Number (Read-only)</label>
                                            <input type="text" className="form-control" value={displayUser.phone_number} readOnly/>
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label">Role</label>
                                            <input type="text" className="form-control" value={displayUser.roles} readOnly/>
                                        </div>
                                        <hr/>
                                        <h5>Change Password</h5>
                                        <div className="mb-3">
                                            <label className="form-label">New Password</label>
                                            <input type="password" className="form-control" value={displayUser.password} onChange={(e) => setDisplayUser({ ...displayUser, password: e.target.value })} placeholder="Leave blank to keep current password"/>
                                            {errors.password && <div className="text-danger">{errors.password[0]}</div>}
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label">Confirm New Password</label>
                                            <input type="password" className="form-control" value={displayUser.password_confirmation} onChange={(e) => setDisplayUser({ ...displayUser, password_confirmation: e.target.value })}/>
                                        </div>
                                        <div className="text-end">
                                            <button type="submit" className="btn btn-primary">Save Changes</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
};

export default UserProfilePage;

